/**
 * Rich Text Editor classes defined here.
 */
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE = 'e-richtexteditor';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTL = 'e-rtl';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CONTENT = 'e-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DISABLED = 'e-disabled';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SCRIPT_SHEET = 'rte-iframe-script-sheet';
/**
 * @hidden
 * @deprecated
 */
export var CLS_STYLE_SHEET = 'rte-iframe-style-sheet';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_CONTAINER = 'e-rte-container';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_IFRAME_CONTENT = 'e-rte-iframe-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TOOLBAR = 'e-rte-toolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_FIXED = 'e-rte-tb-fixed';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_FLOAT = 'e-rte-tb-float';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE = 'e-rte-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_INLINE = 'e-rte-tb-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_EXPAND_TB = 'e-rte-tb-expand';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FULL_SCREEN = 'e-rte-full-screen';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_TB = 'e-rte-quick-toolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TEXT_QUICK_TB = 'e-text-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_QUICK_TB = 'e-image-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_AUDIO_QUICK_TB = 'e-audio-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VIDEO_QUICK_TB = 'e-video-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE_QUICK_TB = 'e-table-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_LINK_QUICK_TB = 'e-link-quicktoolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_STATIC = 'e-tb-static';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_POP = 'e-rte-quick-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE_POP = 'e-rte-inline-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_TBAR_TIP_POINTER = 'e-rte-tip-pointer';
/**
 * @hidden
 * @deprecated
 */
export var CLS_QUICK_DROPDOWN = 'e-quick-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE_TOOLBAR = 'e-rte-inline-toolbar';
/**
 * @hidden
 * @deprecated
 */
export var CLS_INLINE_DROPDOWN = 'e-rte-inline-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_POPUP = 'e-rte-dropdown-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_ICONS = 'e-rte-dropdown-icons';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_ITEMS = 'e-rte-dropdown-items';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_BTN = 'e-rte-dropdown-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_CONTENT = 'e-rte-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_ITEM = 'e-toolbar-item';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_EXTENDED = 'e-toolbar-extended';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_WRAP = 'e-toolbar-wrapper';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POPUP = 'e-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SEPARATOR = 'e-separator';
/**
 * @hidden
 * @deprecated
 */
export var CLS_MINIMIZE = 'e-minimize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_MAXIMIZE = 'e-maximize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACK = 'e-back';
/**
 * @hidden
 * @deprecated
 */
export var CLS_SHOW = 'e-show';
/**
 * @hidden
 * @deprecated
 */
export var CLS_HIDE = 'e-hide';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VISIBLE = 'e-visible';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FOCUS = 'e-focused';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RM_WHITE_SPACE = 'e-remove-white-space';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGRIGHT = 'e-imgright';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGLEFT = 'e-imgleft';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGCENTER = 'e-imgcenter';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGBREAK = 'e-imgbreak';
/**
 * @hidden
 * @deprecated
 */
export var CLS_AUDIOBREAK = 'e-audio-break';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CLICKELEM = 'e-clickelem';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VID_CLICK_ELEM = 'e-video-clickelem';
/**
 * @hidden
 * @deprecated
 */
export var CLS_AUDIOWRAP = 'e-audio-wrap';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VIDEOWRAP = 'e-video-wrap';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VIDEOBREAK = 'e-video-break';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CAPTION = 'e-img-caption';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_CAPTION = 'e-rte-img-caption';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CAPINLINE = 'e-caption-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMGINLINE = 'e-imginline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_AUDIOINLINE = 'e-audio-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VIDEOINLINE = 'e-video-inline';
/**
 * @hidden
 * @deprecated
 */
export var CLS_COUNT = 'e-rte-character-count';
/**
 * @hidden
 * @deprecated
 */
export var CLS_WARNING = 'e-warning';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ERROR = 'e-error';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ICONS = 'e-icons';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ACTIVE = 'e-active';
/**
 * @hidden
 * @deprecated
 */
export var CLS_EXPAND_OPEN = 'e-expand-open';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_ELEMENTS = 'e-rte-elements';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_BTN = 'e-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN_MENU = 'e-rte-dropdown-menu';
/**
 * @hidden
 * @deprecated
 */
export var CLS_HR_SEPARATOR = 'e-rte-horizontal-separator';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TB_IOS_FIX = 'e-tbar-ios-fixed';
/**
 * @hidden
 * @deprecated
 */
export var CLS_LIST_PRIMARY_CONTENT = 'e-rte-list-primary-content';
/**
 * @hidden
 * @deprecated
 */
export var CLS_NUMBERFORMATLIST_TB_BTN = 'e-rte-numberformatlist-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BULLETFORMATLIST_TB_BTN = 'e-rte-bulletformatlist-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CODEBLOCK_TB_BTN = 'e-rte-codeblock-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CODEBLOCK_TB_BTN_ICON = 'e-rte-code-block-icon e-preformat-code';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FORMATS_TB_BTN = 'e-formats-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_NAME_TB_BTN = 'e-font-name-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_SIZE_TB_BTN = 'e-font-size-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_ALIGN_TB_BTN = 'e-alignment-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_LINE_HEIGHT_TB_BTN = 'e-line-height-tbar-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BORDER_STYLE_BTN = 'e-border-style-btn';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BORDERCOLOR_COLORPICKER = 'e-rte-border-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE_BGCOLOR_COLORPICKER = 'e-rte-table-bg-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_FONT_COLORPICKER = 'e-rte-font-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BACKGROUND_COLORPICKER = 'e-rte-background-colorpicker';
/**
 * @hidden
 * @deprecated
 */
export var CLS_NUMBERFORMATLIST_DROPDOWN = 'e-rte-numberformatlist-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_BULLETFORMATLIST_DROPDOWN = 'e-rte-bulletformatlist-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPDOWN = 'e-rte-dropdown';
/**
 * @hidden
 * @deprecated
 */
export var CLS_COLOR_PALETTE = 'e-rte-square-palette';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_READONLY = 'e-rte-readonly';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_HIDDEN = 'e-rte-hidden';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_KEEP_FORMAT = 'e-rte-keepformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_REMOVE_FORMAT = 'e-rte-removeformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_PLAIN_FORMAT = 'e-rte-plainformat';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_OK = 'e-rte-pasteok';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_PASTE_CANCEL = 'e-rte-pastecancel';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_DIALOG_MIN_HEIGHT = 'e-rte-dialog-minheight';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_HANDLE = 'e-resize-handle';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_EAST = 'e-south-east';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_IMAGE = 'e-rte-image';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_UPLOAD_POPUP = 'e-rte-upload-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POPUP_OPEN = 'e-popup-open';
/**
 * @hidden
 * @deprecated
 */
export var CLS_POPUP_CLOSE = 'e-popup-close';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_RESIZE = 'e-img-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_VID_RESIZE = 'e-vid-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_DROPAREA = 'e-droparea';
/**
 * @hidden
 * @deprecated
 */
export var CLS_IMG_INNER = 'e-img-inner';
/**
 * @hidden
 * @deprecated
 */
export var CLS_UPLOAD_FILES = 'e-upload-files';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_DIALOG_UPLOAD = 'e-rte-dialog-upload';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_CNT = 'e-rte-resize';
/**
 * @hidden
 * @deprecated
 */
export var CLS_CUSTOM_TILE = 'e-custom-tile';
/**
 * @hidden
 * @deprecated
 */
export var CLS_NOCOLOR_ITEM = 'e-nocolor-item';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE = 'e-rte-table';
/**
 * @hidden
 * @deprecated
 */
export var CLS_TABLE_BORDER = 'e-rte-table-border';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_FIXED_TB_EXPAND = 'e-rte-fixed-tb-expand';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_TB_ENABLED = 'e-rte-toolbar-enabled';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_RES_WEST = 'e-south-west';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_SOURCE_CODE_TXTAREA = 'e-rte-srctextarea';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_IMAGE_UPLOAD_POPUP = 'e-image-upload-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_VIDEO_UPLOAD_POPUP = 'e-video-upload-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_RTE_AUDIO_UPLOAD_POPUP = 'e-audio-upload-popup';
/**
 * @hidden
 * @deprecated
 */
export var CLS_AI_COMMANDS_TBAR_BTN = 'e-ai-commands-tbar-btn';
